<template>
  <div>
    <v-container class="full-height" style="padding-top: 80px;">
      <v-row justify="center">
        <v-col lg="6">
          <v-card flat :loading="loading" class="bcg">
            <div class="pa-10">
              <h2>Open TRADEinPOOL Account</h2>
              <span
                class="public-text"
              >Boost your trading with best trading journal and community in few steps. Check supported trading platforms and brokers <span class="more">here</span>.</span>
              <!--
              <div class="mt-4">
                <v-icon color="success">check_circle_outline</v-icon>
                <span class="title-small ml-4">14 days free trial</span>
              </div>
              <div class="mt-2">
                <v-icon color="success">check_circle_outline</v-icon>
                <span class="title-small ml-4">No credit card needed</span>
              </div>
              -->
              <div class="register mt-6">
                <v-text-field
                  v-model="form.email"
                  class="register mt-3"
                  label="Email"
                  background-color="#b6c1cb"
                  color="#4dbac0"
                  light
                  filled
                ></v-text-field>

                <v-text-field
                  v-model="form.username"
                  class="register mt-3"
                  label="Username"
                  background-color="#b6c1cb"
                  color="#4dbac0"
                  light
                  filled
                ></v-text-field>
                <v-text-field
                  id="capslock"
                  clear-icon="mdi-close-circle"
                  v-model="form.password"
                  class="register mt-3"
                  label="Password"
                  background-color="#b6c1cb"
                  color="#4dbac0"
                  light
                  filled
                  :type="showPass ? 'text' : 'password'"
                >
                  <template slot="append">
                    <v-icon @click="showPass = !showPass" v-if="showPass">mdi-eye-off</v-icon>
                    <v-icon @click="showPass = !showPass" v-else>mdi-eye</v-icon>
                    <v-icon v-if="capsDetected">keyboard_capslock</v-icon>
                  </template>
                </v-text-field>
              </div>
              <div class="errors">
                <li v-for="(error, index) in errors" :key="index">{{error}}</li>
              </div>
              <div align="right">
                <v-btn @click="register" large color="success" class="mt-3">
                  <v-icon>format_list_numbered</v-icon>
                  <span>Register</span>
                </v-btn>
              </div>
            </div>
          </v-card>
          <div lg="12" align="center" class="mt-4">
            Already have an account?
            <router-link to="/login">Login</router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </div>
</template>

<script>
var moment = require("moment");
export default {
  name: "Register",
  components: {},
  data() {
    return {
      created: Math.round(new Date().getTime() / 1000),
      errors: new Array(),
      loading: false,
      form: {
        email: "",
        username: "",
        password: "",
        timezone: moment.tz.guess()
      },
      capsDetected: false,
      showPass: false
    };
  },
  computed: {},
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);

    var thisis = this;

    document.addEventListener("keyup", function(event) {
      // If "caps lock" is pressed, display the warning text
      if (event.getModifierState("CapsLock")) {
        thisis.capsDetected = true;
      } else {
        thisis.capsDetected = false;
      }
    });
    document.addEventListener("keydown", function(event) {
      // If "caps lock" is pressed, display the warning text
      if (event.getModifierState("CapsLock")) {
        thisis.capsDetected = true;
      } else {
        thisis.capsDetected = false;
      }
    });

    
  },
  methods: {
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    register() {
      // reset fields
      this.errors = [];

      // antispam eliminate by time
      var timeNow = Math.round(new Date().getTime() / 1000);
      if (timeNow < this.created + 4) {
        this.errors.push("Spam bot detected");
      }

      // validate correct email
      if (!this.validateEmail(this.form.email)) {
        this.errors.push("Email is not correct");
      }

      // validate pss min length
      if (this.form.password.length < 8) {
        this.errors.push("Passwords at least 8 characters long");
      }

      // make api call if no errors
      if (this.errors.length == 0) {
        this.form.timezone = "America/Chicago"
        this.$store
          .dispatch("register", this.form)
          .then(() => {
            this.$router.push("/pool");
          })
          .catch(err => {
            if (err.response) {
              this.errors = err.response.data.errors.duplicity;
            }
          });
      } else {
        this.form.password = "";
        this.created = Math.round(new Date().getTime() / 1000);
      }
    }
  }
};
</script>

<style scoped>
.public-text {
  color: #b6c1ca;
}
.title-small {
  font-family: "Roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 20px;
}
.bcg {
  background-image: url(../assets/img/logo-cropped.svg);
  background-size: cover;
}
</style>